import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'
import {
  FullSuccessSVG,
  FullErrorSVG,
  FullInfoSVG,
  FullWarningSVG,
} from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import { StyledTextButton } from '../Buttons/TextButton/TextButton'

export const MessageContainer = styled.div<{
  backgroundColor: string
  borderColor: string
  padding: string
  $fullWidth?: boolean
}>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: ${({ padding }) => padding || '16px'};
  border-radius: 8px;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || palette.blue[100]};
  border: 1px solid ${({ borderColor }) => borderColor || palette.blue[200]};
`

export const MessageErrorIcon = styled(FullErrorSVG)`
  height: 24px;
  width: 24px;
  margin: 2px;
  path {
    fill: ${palette.magenta[500]};
  }
`

export const MessageWarningIcon = styled(FullWarningSVG)`
  height: 24px;
  width: 24px;
  margin: 2px;
  fill: ${palette.orange[500]};
`

export const MessageInfoIcon = styled(FullInfoSVG)`
  height: 24px;
  width: 24px;
  margin: 2px;
  fill: ${palette.blue[500]};
`

export const MessageSuccessIcon = styled(FullSuccessSVG)`
  height: 24px;
  width: 24px;
  margin: 2px;
  fill: ${palette.green[500]};
`

export const MessageIcon = styled.div<{
  $size: 'small' | 'medium'
}>`
  svg {
    height: ${({ $size }) => ($size === 'small' ? '16px' : '24px')};
    width: ${({ $size }) => ($size === 'small' ? '16px' : '24px')};
    flex-shrink: 0;
  }
`

export const MessageContent = styled.div<{
  $fullWidth?: boolean
}>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  ${({ $fullWidth }) => $fullWidth && 'flex: 1;'}
`

export const MessageText = styled.p<{
  $size: 'small' | 'medium'
}>`
  margin: 0;
  line-height: 20px;
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : '14px')};
  font-weight: 400;
`

const ctaStyles = `
  line-height: 20px;
  font-weight: 500;
  color: ${palette.blue[600]};
  text-decoration: none;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  white-space: nowrap;
`

export const MessageCTAButton = styled(StyledTextButton)<{
  $withMargin?: boolean
  $size: 'small' | 'medium'
}>`
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : '14px')};
  ${ctaStyles}
  ${({ $withMargin }) =>
    $withMargin &&
    `
    margin-left: 28px;
  `}
`

export const MessageCTALink = styled.a<{
  $withMargin?: boolean
  $size: 'small' | 'medium'
}>`
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : '14px')};
  ${ctaStyles}
  ${({ $withMargin }) =>
    $withMargin &&
    `
    margin-left: 28px;
  `}
`

export const MessageCTARouterLink = styled(Link)<{
  $withMargin?: boolean
  $size: 'small' | 'medium'
}>`
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : '14px')};
  ${ctaStyles}
  margin-right: 8px;
  &,
  &:visited,
  &:hover,
  &:active {
    color: ${palette.blue[600]};
  }
  ${({ $withMargin }) =>
    $withMargin &&
    `
    margin-left: 28px;
  `}
`

export const MessageCloseButton = styled.button<{
  $size: 'small' | 'medium'
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-left: auto;

  svg {
    width: ${({ $size }) => ($size === 'small' ? '14px' : '16px')};
    height: ${({ $size }) => ($size === 'small' ? '14px' : '16px')};
    fill: ${palette.neutral[600]};
  }

  &:hover svg {
    fill: ${palette.neutral[900]};
  }
`
